import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';
import { captureException } from '@/libs/logger';

/** Path (relative to `buildUrl`) for the caller's FCM device tokens. */
export const DEVICE_TOKENS_ENDPOINT = '/me/device-tokens';

/** Body for POST /api/v1/me/device-tokens. */
type DeviceTokenRequest = { token: string };

type DeviceTokenResponse = { token: string; updatedAt: string };

export async function uploadDeviceToken(token: string): Promise<void> {
  try {
    await usKidsGolfService.post<DeviceTokenResponse, DeviceTokenRequest>(
      buildUrl(DEVICE_TOKENS_ENDPOINT),
      { token },
    );
  } catch (e) {
    captureException({ error_payload: e }, { tags: { usk_log_type: 'device_token_upload_error' } });
  }
}

/**
 * DELETE the token. Call before sign-out (while auth token is still valid).
 *
 * `authToken` pins the bearer for this call. During sign-out the DELETE can
 * outlive the 3s race that guards `signOut` and fire *after* Firebase has
 * cleared `currentUser` — at which point the interceptor has no ID token to
 * attach and the backend rejects with "missing bearer token". Passing a token
 * captured while auth was still valid avoids that.
 */
export async function removeDeviceToken(token: string, authToken?: string): Promise<void> {
  try {
    await usKidsGolfService.deleteWithBody<void, DeviceTokenRequest>(
      buildUrl(DEVICE_TOKENS_ENDPOINT),
      { token },
      authToken ? { authToken } : undefined,
    );
  } catch (e) {
    captureException({ error_payload: e }, { tags: { usk_log_type: 'device_token_remove_error' } });
  }
}
